<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
  <button style="float: right;" type="button" class="btn btn-primary" (click)="goBack()">{{'BATCH.BACK' | translate }}</button>
  @if (batchProcess==null) {
    <div div class="loader center"></div>
  }
  @if (batchProcess) {
    <div>
      <div class="divStyle"><br /><label class="labelStyle">{{'BATCH.FILENAME' | translate }}: </label><span class="spanStyle">{{batchProcess.fileName}}</span>
      <br /><label class="labelStyle">{{'BATCH.SERVICE' | translate }}: </label><span class="spanStyle">{{batchProcess.serviceName}}</span>
      <br /><label class="labelStyle">{{'BATCH.FILE_FORMAT' | translate }}: </label><span class="spanStyle">{{batchProcess.fileFormatName}}</span>
      <br /><label class="labelStyle">{{'BATCH.PROCESSED_RECORDS' | translate }}: </label><span class="spanStyle">{{batchProcess.processedRecords}}</span>
      <br /><label class="labelStyle">{{'BATCH.TOTAL_RECORDS' | translate }}: </label><span class="spanStyle">{{batchProcess.numberOfRecords}}</span>
      <br /><label class="labelStyle">{{'BATCH.START_TIME' | translate }}: </label><span class="spanStyle">{{batchProcess.processStartTime | date: 'dd/MM/yyyy'}}</span>
      <br /><label class="labelStyle">{{'BATCH.END_TIME' | translate }}: </label><span class="spanStyle">{{batchProcess.processEndTime | date: 'dd/MM/yyyy'}}</span>
      <br /><label class="labelStyle">{{'BATCH.STATUS' | translate }}: </label><span class="spanStyle">{{batchProcess.status==1?'In Progress':'Done'}}</span>
    </div>
  </div>
}
</div>